const _version = "2.6.8"
function version() {
    return _version;
}
export default version
